export {};

import { PerkSlider } from '../modules/perk-slider';

const container = document.querySelector('.banner-perk');
if (container) new PerkSlider(container);
